import * as React from 'react';
export const Conclusion = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={154} height={154}>
    <g transform="translate(-118 -226)">
      <circle cx={77} cy={77} r={77} fill="#e5f7f4" transform="translate(118 226)" />
      <circle cx={60} cy={60} r={60} fill="#00b193" data-name="Ellipse" transform="translate(135 243)" />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={9}
        d="m228.328 285.037-43.583 39.338-19.28-19.281"
      />
    </g>
  </svg>
);
